import { PermissionRelationObjectType } from '@/interfaces/permissionRelationObjectType';
import { permissionRelationResource, PermissionRelationResource } from '@/resources/permissionRelation.resource';
import store from '@/store/store';
import { AbstractModule } from '../abstract.module';

/**
 * Moduł uprawnień ról
 *
 * @class PermissionRelationModule
 * @extends {AbstractModule<PermissionRelationResource>}
 */
class PermissionRelationModule extends AbstractModule<PermissionRelationResource> {
  public state = {
    list: [],
    count: undefined
  };

  public mutations = {
    /**
     * Zapisuje listę do store
     *
     * @param {*} localState
     * @param {PermissionRelationObjectType[]} list
     */
    saveList(localState: any, list: PermissionRelationObjectType[]): void {
      localState.list = list;
      localState.count = list.length;
    },
    /**
     * Usuwa encję z listy
     *
     * @param localState stan lokalny
     * @param id identyfikator encji
     */
    remove(localState: any, id: number): void {
      localState.list.splice(localState.list.findIndex((item: any) => item.permission.id === id), 1);
      localState.count -= 1;
    }
  };
  public actions = {
    /**
     * Pobiera listę encji
     *
     * @param context context
     */
    list: async (context: any): Promise<void> => {
      const list = await this.resource.list(context.rootState.role.id);
      context.commit('saveList', list);
    },
    /**
     * Usuwa encję
     *
     * @param context context
     * @param permissionId id uprawnienia
     */
    remove: async (context: any, permissionId: number): Promise<void> => {
      await this.resource.delete(permissionId, context.rootState.role.id);
      context.commit('remove', permissionId);
    },
    /**
     * Dodaje encję
     *
     * @param context context
     * @param data dane do wysłania do API
     */
    add: async (context: any, data: any): Promise<void> => {
      await this.resource.add(data.permissionId, data.roleId);
      store.dispatch('role/permission/list', data.roleId);
    }
  };
}

export default new PermissionRelationModule(permissionRelationResource);
